var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotesBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn/icon/24x24-notes+bookmark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/receipt-edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0009 2.08325C12.0177 2.08325 8.75613 2.59348 6.66356 4.93438C4.61304 7.22825 4.16797 10.7624 4.16797 15.1722V39.9839C4.16797 41.7666 4.57241 43.3052 5.43253 44.549C6.28827 45.7864 7.46724 46.5471 8.7025 47.0194C11.049 47.9166 14.0416 47.9166 16.5706 47.9166H31.3487C33.8777 47.9166 36.8702 47.9166 39.2167 47.0194C40.452 46.5471 41.631 45.7864 42.4867 44.549C43.3468 43.3052 43.7513 41.7666 43.7513 39.9839L43.7513 15.1722C43.7513 10.7624 43.3062 7.22825 41.2557 4.93438C39.1631 2.59348 35.9016 2.08325 31.9184 2.08325H16.0009ZM39.9614 15.1722C39.9614 10.7019 39.4169 8.68308 38.4881 7.6441C37.6014 6.65216 35.894 6.0496 31.9184 6.0496H16.0009C12.0253 6.0496 10.3178 6.65216 9.43114 7.6441C8.50238 8.68308 7.95786 10.7019 7.95786 15.1722V39.9839C7.95786 41.1318 8.21139 41.8023 8.50271 42.2235C8.79842 42.6511 9.26437 43.0115 10.003 43.2939C11.5982 43.9038 13.8599 43.9502 16.5904 43.9502H31.3288C34.0593 43.9502 36.3211 43.9038 37.9162 43.2939C38.6549 43.0115 39.1208 42.6511 39.4165 42.2235C39.7078 41.8023 39.9614 41.1318 39.9614 39.9839L39.9614 15.1722Z",
    fill: "#0082CD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.538 18.0667L17.8877 26.7171C17.5456 27.0592 17.2279 27.6945 17.1546 28.1588L16.6903 31.4577C16.5192 32.655 17.3501 33.4859 18.5474 33.3148L21.8463 32.8506C22.3106 32.7772 22.9704 32.4595 23.288 32.1174L31.9384 23.4671C33.429 21.9765 34.1377 20.2416 31.9384 18.0423C29.7636 15.8675 28.0286 16.5761 26.538 18.0667Z",
    stroke: "#0082CD",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.2891 19.313C26.0221 21.9521 28.0748 24.0047 30.7139 24.7378",
    stroke: "#0082CD",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesBig);
export default __webpack_public_path__ + "static/media/notes-big.73345d4e25892e48dbd7f17ca627e0ba.svg";
export { ForwardRef as ReactComponent };